import { FC, useState } from "react";
import type { OsMASettings } from "../../model";
import styles from "./AcceleratorOscillatorInputsTab.module.css";

type InputKey = "fastEmaPeriod" | "slowEmaPeriod" | "signalSmaPeriod";
type InputValues = Record<InputKey, string>;

const FIELDS: { key: InputKey; label: string }[] = [
  { key: "fastEmaPeriod", label: "Fast EMA Period" },
  { key: "slowEmaPeriod", label: "Slow EMA Period" },
  { key: "signalSmaPeriod", label: "Signal SMA Period" },
];

interface Props {
  settings: OsMASettings;
  onChange: (settings: OsMASettings) => void;
}

export const OsMAInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [values, setValues] = useState<InputValues>({
    fastEmaPeriod: String(settings.fastEmaPeriod),
    slowEmaPeriod: String(settings.slowEmaPeriod),
    signalSmaPeriod: String(settings.signalSmaPeriod),
  });

  const handleChange = (key: InputKey, value: string) =>
    setValues((prev) => ({ ...prev, [key]: value }));

  const handleBlur = (key: InputKey) => {
    const parsed = parseInt(values[key], 10);
    const clamped = isNaN(parsed) ? settings[key] : Math.min(Math.max(1, parsed), 250);
    setValues((prev) => ({ ...prev, [key]: String(clamped) }));
    onChange({ ...settings, [key]: clamped });
  };

  return (
    <div className={styles.tab}>
      {FIELDS.map(({ key, label }) => (
        <div key={key} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <input
            type="number"
            className={styles.input}
            min={1}
            max={250}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            onBlur={() => handleBlur(key)}
          />
        </div>
      ))}
    </div>
  );
};
